<template lang="pug">
.mt-4
  .px-4.pb-8
    div
      | The Home Office requires
      | at least 4-mandatory documents
      | to support your application;
      | however, typically,
      | an up-to-date Org chart
      | is also required.
      | Therefore, in total,
      | you must provide
      | 5-mandatory documents.
      | The documents must be
      | the originals or certified copies.
      | Any documents
      | not in English or Welsh
      | must be accompanied
      | by a certified translation.

    br

    div
      b.mr-2 Status:
      template(v-if="mandatoryDocsNumber <= 3")
        v-icon(color="error")
          | mdi-alert-decagram
      template(v-else)
        v-icon(color="success")
          | mdi-check-circle

    br

    div
      template(v-if="mandatoryDocsNumber <= 3")
        div
          | Based on the information you've submitted,
          | your company won’t be able
          | to provide 5-mandatory documents
          | required by the Home Office at this time.

        div
          | You can make necessary changes in the
          |
          a(@click="$emit('goto', 2)")
            | Case profile
          |
          | or
          |
          a(@click="$router.push('/company')")
            | Company profile tabs
          | ,
          | and the status and list of documents
          | will be re-assessed.

      template(v-else)
        div
          | Based on the information you've submitted,
          | your company can provide 5-mandatory documents
          | required by the Home Office.

        br

        div
          | It is the best practice
          | to provide the Home Office
          | with as much evidence as possible,
          | so please upload
          | all mandatory documents
          | listed below
          | (even if the number exceeds 5 documents).
          | If you are not able to provide
          | all mandatory documents
          | please leave the comment
          | explaining the reason.

        br

        div
          | The total size of all documents
          | must be less than 20 MB,
          | it is a Home Office requirement.

  template(v-if="isPaid")
    v-card(color="#f8f9fc")
      v-card-text
        div(
          v-for="(panel, i) in panels",
          :key="panel.status",
          :class="[!!i && 'pt-6']"
        )
          h2.mb-4
            | {{ panel.status }} documents
          v-expansion-panels(
            flat,
            focusable,
            :value="panel.expanded",
            @input="panel.setExpanded"
          )
            Doc(
              v-for="doc in panel.docs",
              :key="doc.ID",
              :data="doc",
              :badge="getBadge(doc)"
            )
</template>

<script>
import Doc from "./Docs";
import { mapGetters, mapState } from "vuex";

export default {
  name: "employer-case-documents",

  components: {
    Doc,
  },

  data: () => ({
    docPanels: ["Mandatory", "Recommended", "Potential"].map((status) => ({
      status,
      expanded: false,
    })),
  }),

  mounted() {
    this.$store.dispatch("usercase/sponsorship/refreshDocuments");
  },

  methods: {
    getBadge(doc) {
      let color = "";
      let text = "";
      switch (doc.decision) {
        case "approved":
          color = "success";
          text = "Approved";
          break;
        case "unapproved":
          color = "error";
          text = "Unapproved";
          break;
        case "requested_change":
          color = "error";
          text = "Request another document";
          break;
      }
      return { color, text };
    },
  },

  computed: {
    ...mapState("usercase/sponsorship", ["documents"]),
    ...mapGetters("usercase", ["ID", "isPaid"]),

    panels() {
      if (this.documents) {
        return this.docPanels
          .map((docPanel) => ({
            ...docPanel,
            docs: this.documents.filter(
              (doc) => doc.status === docPanel.status
            ),
            setExpanded: (v) => (docPanel.expanded = v),
          }))
          .filter((panel) => panel.docs.length > 0);
      }
      return [];
    },

    mandatoryDocsNumber() {
      return (
        this.panels.find(({ status }) => status === "Mandatory")?.docs.length ??
        0
      );
    },
  },
};
</script>